import { Field } from 'Util/Query';

/** @namespace PeggysagePwa/Query/HelpDesk/Query */
export class HelpDeskQuery {
    getTickets() {
        return this._ticketsQuery();
    }

    getTicket(_id) {
        return new Field('customer').addFieldList([
            new Field('ticket')
                .addArgument('filter', 'CustomerTicketsFilterInput', {
                    external_id: {
                        eq: _id
                    }
                })
                .addFieldList(this._Fields())
        ]);
    }

    getExternalTicket(options) {
        const {
            message_id,
            third_id,
            external_id
        } = options;

        return new Field('externalTicket')
            // .addArgument('filter', 'CustomerTicketsFilterInput', null)
            .addArgument('input', 'ExternalTicketInput', {
                message_id,
                third_id,
                external_id
            })
            .addFieldList(this._Fields(true));
    }

    replyToTicket(options) {
        const {
            id: external_id,
            message,
            files,
            message_id,
            third_id
        } = options;

        const input = {
            external_id,
            message,
            files
        };

        if (message_id) {
            input.message_id = message_id;
        }

        if (third_id) {
            input.third_id = third_id;
        }

        return new Field('ticketAddMessage')
            .addArgument('input', 'ticketAddMessage!', input)
            .addFieldList(['message']);
    }

    createTicket(options) {
        const {
            subject, order_id, message, files
        } = options;

        return new Field('ticketCreateForm')
            .addArgument('input', 'ticketCreateForm!', {
                subject, order_id, message, files
            })
            .addFieldList(['message']);
    }

    _ticketsQuery() {
        return new Field('customer').addFieldList([
            new Field('tickets').addFieldList([this._ticketFields()])
        ]);
    }

    _ticketFields() {
        return new Field('items').addFieldList(this._Fields());
    }

    _Fields(isExternal = false) {
        const fields = [
            'external_id',
            'code',
            'subject',
            'priority_id',
            'priority',
            'status_id',
            'status',
            'customer_email',
            'customer_name',
            'order_id',
            'order_increment_id',
            'last_reply_name',
            'created_at',
            this._messageFields(isExternal)
        ];

        if (isExternal) {
            fields.push(
                'third_party_email',
                'third_party_name',
                'third_party_ids'
            );
        }

        return fields;
    }

    _messageFields(isExternal = false) {
        const fieldList = [
            'message_id',
            'body',
            'body_format',
            'created_at',
            'updated_at',
            'uid',
            'type',
            'triggered_by',
            'display_name',
            'is_read',
            this._messageAttachentFields()
        ];

        if (isExternal) {
            fieldList.push(
                'third_party_email',
                'third_party_name',
                'third_party_ids'
            );
        }

        return new Field('messages').addFieldList(fieldList);
    }

    _messageAttachentFields() {
        return new Field('attachments').addFieldList([
            'attachment_id',
            'name',
            'type',
            'external_id',
            'url'
        ]);
    }
}

export default new HelpDeskQuery();
